<template>
	<div class="p_box" id="box">
		<div id="head">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/Homet' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item>错题批改</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="mine_header p_m_t_30" id="tab">
			<div class=" header_left p_flex p_f_a ">
				<div class="p_flex p_f_a small_hand" v-for="(item, index) in headerList" :key="index" @click="goHeader(index)">
					<div :class="[headerIndex == index ? 'tababr_com' : '']">{{ item.name }}</div>
					<div v-show="headerIndex == index" class="header_heng"></div>
				</div>
			</div>
		</div>
		<div class="mine_list overflow small_hand" :style="{ height: height + 'px' }">
			<wrong-list  :i='headerIndex'></wrong-list>
		</div>
		
	</div>
</template>

<script>
import WrongList from './commponents/wrongList.vue';
export default {
	name: 'Mistake',
	components:{
		WrongList
	},
	data() {
		return {
			headerIndex: 0,
			headerList: [
				{
					name: '待批改'
				},
				{
					name: '已完成'
				}
			],
			show: false,
			height: 0
		};
	},
	mounted() {
		this.indexInfo();
	},
	watch: {
		'$route.path': {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal == '/Mistake') {
					var height = localStorage.getItem('height');
					if (height == '') {
					} else {
						this.height = height;
					}
				}
			}
		}
	},
	beforeRouteLeave(to, form, next) {
		localStorage.removeItem('height');
		next();
	},
	methods: {
		indexInfo() {
			var box = document.getElementById('box').offsetHeight;
			var head = document.getElementById('head').offsetHeight;
			var tab = document.getElementById('tab');
			var tabHeight = tab.offsetHeight;
			var tabTop = tab.offsetTop;
			var height = box - head - tabHeight - 30;
			var heights = localStorage.getItem('height');
			if (heights == null) {
				localStorage.setItem('height', height);
			} else {
			}
			this.height = height;
		},
		// 头部切换
		goHeader(i) {
			this.headerIndex = i;
		}
	}
};
</script>
<style lang="scss" scoped>
.mine_header {
	background-color: #fafafa;
	height: 60px;
}

.header_left > div {
	height: 100%;
	position: relative;
	margin-left: 260px;
}

.header_left > div:nth-child(2) {
	margin-left: 50px;
}

.header_left {
	height: 100%;
}

.header_heng {
	position: absolute;
	bottom: 0;
	left: 50%;
	transform: translateX(-50%);
	width: 80%;
	height: 2px;
	background-color: #000000;
}
.tababr_com {
	font-weight: bold;
}
.heaer_btn {
	margin-left: 440px;
}
.mine_list {
	padding: 0;
	background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/mistake/index.vue